import styled, { createGlobalStyle, css } from "styled-components";
import { FlexboxGrid, Form } from "rsuite";
import Button from "rsuite/es/Button";

export const GlobalStyle = createGlobalStyle`
    .rs-picker-menu .ReactVirtualized__Grid__innerScrollContainer > div:nth-child(1) .rs-picker-select-menu-item {
        padding: 18px !important;
    }
`;

export const CenteredForm = styled(Form)`
    && {
        width: 100%;
        margin: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

export const StyledLabel = styled.span`
    ${props => props.display === "block" ? css`
        display: block;
    ` : css`
        display: inline-block;
    `}

    ${props => !props.compact && css`
        width: 100%;
    `}

    ${props => props.width && css`
        min-width: ${props.width}px;
        max-width: ${props.width}px;
        width: ${props.width}px;
    `}

    && {
        ${props => props.margin && css`
            margin: ${props.margin};
        `}
    }

    margin-right: 10px;
    margin-bottom: 5px;

    .rs-icon {
        margin-left: 10px;
    }
`;

export const StyledContainerColumn = styled.div`
    && {
        display: flex;
        flex-direction: column;

        ${props => props.margin && css`
            margin: ${props.margin};
        `}
    }
    .rs-form-group {
        margin-bottom: 10px;
    }
    && .textarea {
        margin-bottom: 10px;
        width: 100%;
        height: 80px;
        min-width: 400px;
        resize: auto;
    }
    && .ivr_select {
        width: 300px;
    }
`;

export const StyledContainerRow = styled.div`
    && {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-bottom: 10px;
        ${props => props.start ? css`
            justify-content: flex-start;
        ` : css`
            justify-content: space-between;
        `}

        ${props => props.maxWidth && css`
            max-width: ${props.maxWidth}px;
        `}

        ${props => props.margin && css`
            margin: ${props.margin};
        `}
    }
`;

export const StyledGrid = styled(FlexboxGrid)`
    ${props => props.isMobile && css`
        &&& {
            flex-direction: column;
        }
    `}
`;

export const ResellerRatesRow = styled(FlexboxGrid)`
    &&& {
        flex: 0 0 100%;
        flex-wrap: nowrap;
        justify-content: center;
        width: 100%;

        ${props => props.isMobile && css`
            align-items: flex-start;
            flex-direction: column;
        `}
    }
`;

export const StyledColumn = styled(FlexboxGrid)`
    &&& {
        flex-direction: column;
    }
`;

export const StyledFormStretched = styled.div`
    && {
        margin: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }
    && .column {
        min-width: 400px;
    }
    && .column > .rs-form-group {
        margin-bottom: 10px;
        width: 100%;
        display: flex;
        align-content: space-between;
    }
    && .column > .rs-form-group .rs-form-control-wrapper {
        width: 100%;
    }
    && .column > .rs-form-group input {
        width: 100%;
    }
    && .protocol {
        margin-bottom: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
`;

export const StyledFormStart = styled.div`
    && {
        margin: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    && .column {
        min-width: 400px;
    }
`;

export const StyledButton = styled(Button)`
    ${props => !props.withoutMargin && (!props.under ? css`
        margin-top: 10px;
        ${props.open && "margin-bottom: 20px !important"};
    ` : css`
        margin-bottom: 20px !important;
    `)};
    width: 140px;
    .right {
      float: right;
    }
`;

export const TermPointItem = styled.div`
    && {
        width: 100%;
        margin-bottom: 20px;

        .rs-form-group {
            display: flex;
            width: 100%;
            justify-content: center;
            margin-top: 0px;
        }
    }
`;
